import getUserAgent from 'functions/getUserAgent';

export const isIOS = () => {
  const userAgent = getUserAgent();

  return userAgent ? /iPad|iPhone|iPod/.test(userAgent) : false;
};
